import { render } from "./ContactSection.vue?vue&type=template&id=a66ce798&scoped=true"
const script = {}

import "./ContactSection.vue?vue&type=style&index=0&id=a66ce798&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a66ce798"]])

export default __exports__